import errorIcon from 'assets/images/icon-error.svg'

const input = {
  Form: {
    variants: {
      floating: {
        container: {
          _focusWithin: {
            'label:not(.chakra-checkbox)': {
              transform: 'scale(0.85) translateY(-30px)',
              color: 'primary.500'
            }
          },
          'input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label': {
            transform: 'scale(0.85) translateY(-30px)',
            color: 'neutral.110',
          },
          'label.chakra-form__label': {
            top: 0,
            left: 0,
            zIndex: 2,
            position: 'absolute',
            fontSize: '14px',
            pointerEvents: 'none',
            color: 'neutral.110',
            mx: 3,
            px: 1,
            my: 2,
            transformOrigin: 'left top'
          }
        }
      }
    },
    defaultProps: {
      variant: 'floating',
    }
  },
  Input: {
    variants: {
      outline: {
        field: {
          fontSize: '14px',
          h: '40px',
          fontWeight: '400',
          borderColor: 'secondary.400',
          color: 'secondary.400',
          _hover: {
            borderColor: 'secondary.400'
          },
          _disabled: {
            borderColor: 'secondary.100',
            color: 'secondary.100',
            bg:'white',
            opacity: '1',
            _hover: {
              borderColor: 'secondary.100'
            }
          },
          _invalid: {
            borderColor: 'destructive.400',
            boxShadow: '0',
            color: 'destructive.400',
            bgImage: `url('${errorIcon}')`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '97% center',
            paddingRight: '35px'
          }
        }
      }
    }
  },
  FormError: {
    baseStyle: {
      text: {
        color: 'destructive.400',
        position: 'absolute',
        fontSize: '12px',
        mt: 0,
        left: '14px'
      }
    }
  }
}

export default input
